<script>
  import { getStr } from '../../../../common/util';
  import { ratingMixPanel, totalReviewsMixPanel } from '../../store/pdp_store';
  import IndividualRateRow from './IndividualRateRow.svelte';

  export let scoreDist;
  export let score;

  const numberFormatter = Intl.NumberFormat('en-US');

  $: aggregatedScoreDist = computeAggregatedScoreDist(scoreDist);
  $: totalReviews = computeTotalReviews(aggregatedScoreDist);
  $: totalReviewsFormatted = numberFormatter.format(totalReviews);
  $: scoreBy2 = (score / 2).toFixed(1);
  $: {
    if (totalReviewsFormatted) {
      totalReviewsMixPanel.set(totalReviewsFormatted);
      ratingMixPanel.set(scoreBy2);
    }
  }

  function computeAggregatedScoreDist({ pro_score_dist_all, user_score_dist_all, your_score_dist }) {
    return [pro_score_dist_all, user_score_dist_all, your_score_dist]
      .filter(x => x !== undefined)
      .reduce((prevArray, currArray) => currArray.map((c, ci) => c + prevArray[ci]), [0, 0, 0, 0, 0]);
  }
  function computeTotalReviews(scoreAggDist) {
    return scoreAggDist.reduce((prev, curr) => prev + curr, 0);
  }
</script>

{#if totalReviews > 0 && score > 0}
  <section class="rating-summary-container">
    <section class="rating-overall">
      <section class="rating">{scoreBy2}</section>
      <section class="reviews">
        {totalReviewsFormatted}
        {getStr('extra.pdp.review')}
      </section>
    </section>
    <section class="rating-individual">
      {#each [...aggregatedScoreDist].reverse() as agScore, index}
        <IndividualRateRow rating={5 - index} number={agScore} barPercent={(agScore * 100) / totalReviews} />
      {/each}
    </section>
  </section>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .rating-summary-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: $neutral-light-05;
    padding: 37px 25.5px 0px;
    border-radius: 12px;

    @include desktop-min-width {
      flex-direction: row;
      gap: 35px;
      background-color: unset;
      padding: unset;
      border-radius: unset;
      margin: unset;
      max-width: unset;
    }

    .rating-overall {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .rating {
        font-weight: 700;
        font-size: 36px;
        line-height: 40px;
      }
      .reviews {
        font-weight: 400;
        font-size: 18px;
        line-height: 20px;
      }
    }
    .rating-individual {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  }
</style>
